import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from '../../../tableSettings';
import {
  DateRenderer,DateTimeRenderer, FloatRenderer, NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';
import AbstractListView, {
  DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import {Search} from '../../../filtering';
import {JobNames} from '../../../framework.core/JobNames';
import {airExportMawbList} from '../tableSettings';
import {AeMblListItem} from '../../../fms.data/models/AeMblListItem';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import {useHistory} from 'react-router';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import ApplicationContext from '../../../ApplicationContext';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import loadInfoAreaInvoiceBillCrDb from '../../../components/common/InfoAreaInvoiceBillCrDb';
import IfmsModal from "../../../ui/IfmsModal";
import MawbMilestonePopup from "./MawbMilestonePopup";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer, ShipmentTypeFilterRenderer, ShipmentTypeRenderer } from '../../common/commonListRenderers';
import Select from '../../../ui/Select';
import * as XCol from '../../../framework.core/XExportColumn';
import DeleteHistory from "../../reports/DeleteHistory";
import postal from 'postal';
import { FmsSecTask } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask, isEawbEnabled } from '../../../util';
import { EawbEdiStatusText, FreightStatusText } from '../../../fms.core/pims/Eawb';
import EawbHistoryPopup from '../eawb/implementation/EawbHistoryDialog';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import fastStorage from '../../../fastStorage';
import _ from 'lodash';
import RecogModal from '../../../ui/RecogModal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import constants from '../../../constants';
import { formatAEBlType, formatShipmentType } from '../../common/utils/formatUtils';
import { Decimalformat } from '../../common/commonExportFormat';
import { AeHblListItem } from '../../../fms.data/models/AeHblListItem';
import { faPlus} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BillingsIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, RecogHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import { SecType } from '../../../fms.enum';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';
import taskReminderIconRed from '../../../img/pin_red.svg';
import { AeHbl } from '../../../fms.core/AeHbl';

function useMawbOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);

  function switchToHawbFor(mawb: AeMblListItem | null) {
    const hawbSec = findSecurityTask(appContext, FmsSecTask.AEHbl);

    if (!mawb || !hawbSec.grantRead) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/aeHawb/airExport', 
    'aeMblId', 'Ref. #', mawb.id, 'u2Date', false, true, null, 'refNo', mawb.refNo, false,true);
    openNewPage(history, `/common/joblistview/aeHawb/airExport`, NavigationType.newPage);
  }

  async function switchToAcctInfo(mawb:AeMblListItem|null) {
    if (!mawb) {
      return;
    }

    openNewPage(history, `/accounting/Acct/${JobNames.AEMbl}/${mawb.id}`, NavigationType.newPage);
  }

  return {switchToHawbFor, switchToAcctInfo};
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useMawbOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em', textDecoration: 'underline'}}>{value}</PrimaryInverseButton>
}

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }
  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`}  data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function BlTypeRenderer({ cell }: any) {
  let value = '';

  if (cell.value === 'D') {
    value = 'Regular';
  } else if (cell.value === 'C') {
    value = 'Consol';
  } else if (cell.value === 'L') {
    value = 'Co-Load';
  }

  return (
    <div className="ifms-table-default" data-cell-actual-value={cell.value}>{value}</div>
  );
}

// e-AWB FWB/FHL 상태 코드 → 표시 문구 (EAwbStatus.cs Collection 대응, BlTypeRenderer 패턴).
// 3.3 ListRenderer 와 동일하게 마우스오버 시 "FWB Accepted" 식 툴팁(IndicatorRenderer 의 data-tooltip 규칙),
// 클릭 시 e-AWB 이력 팝업(ShowEawbHistoryView 대응).
function EawbStatusRenderer({ cell, data, row }: any) {
  const [historyOpen, setHistoryOpen] = useState(false);
  // 빈값(미전송)은 공백으로 표시
  const text = cell.value ? (EawbEdiStatusText[cell.value] ?? cell.value) : '';
  const dataTooltip = cell.value ? `${(cell.column?.id === 'fhl') ? 'FHL' : 'FWB'} ${text}` : '';
  const mawbNo = data[row.index]?.mawbNo ?? '';
  return (
    <>
      {/* 팝업을 클릭 div 의 형제로 렌더 — 자식으로 두면 팝업 내부 클릭이 React 트리로 버블되어 다시 열린다 */}
      <div className="ifms-table-default" data-cell-actual-value={cell.value} data-tooltip={dataTooltip}
        style={{ cursor: 'pointer' }} onClick={() => setHistoryOpen(true)}>{text}</div>
      {historyOpen && <EawbHistoryPopup mawbNo={mawbNo} onClose={() => setHistoryOpen(false)} />}
    </>
  );
}

// FRT Status(F_Fsu) — 코드는 그대로 표시하고 툴팁으로 설명(3.3 FreightStatusCode.Collection), 클릭 시 이력 팝업.
function FrtStatusRenderer({ cell, data, row }: any) {
  const [historyOpen, setHistoryOpen] = useState(false);
  const dataTooltip = FreightStatusText[cell.value ?? ''] ?? '';
  const mawbNo = data[row.index]?.mawbNo ?? '';
  return (
    <>
      <div className="ifms-table-default" data-cell-actual-value={cell.value} data-tooltip={dataTooltip}
        style={{ cursor: 'pointer' }} onClick={() => setHistoryOpen(true)}>{cell.value}</div>
      {historyOpen && <EawbHistoryPopup mawbNo={mawbNo} onClose={() => setHistoryOpen(false)} />}
    </>
  );
}

function BlTypeFilterRenderer({value, onChange}:any) {
  return (
    <Select
    name='ifms-filter-blType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        // { label: '', value: '' },
        { label: 'Regular', value: 'D' },
        { label: 'Consol', value: 'C' },
        { label: 'Co-Load', value: 'L' },
      ]}      
    />
  );
}

function MemoDetailRenderer({value, data, row}: any) {
  const {openDocServer} = useSelectedMawbOperation();

  const memoCnt = value;

  if(memoCnt === '0'){
    return <div className="ifms-table-default">{value}</div>;
  }

  return <div onClick={() => openDocServer(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em', cursor:'pointer'}}>{value}</div>
}

function RefNoRenderer({value, data, row, cell}: any){
    
  const isPending = data[row.index].taskPendingCnt > 0;

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">
      {value}{isPending ? <img style={{marginBottom:'1px', marginLeft:'3px'}}width='11px' height='11px' src={taskReminderIconRed} />: <></>}
    </div>
}

function AgentRenderer({ cell, value, data, row }: any) {
  const agentCnt  = (data[row.index].agentCnt - 1);

  return ( 
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">{value}{agentCnt > 0 ? ' + ' + agentCnt : ''}</div>
  );
}

function useSelectedMawbOperation() {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  const { switchToHawbFor } = useMawbOperations();

  const selectedElement = jobListContext.selectedElement as AeMblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');


  function openDocServer(mawb:AeMblListItem|null){
    if (!mawb) {
      return;
    }

    if(appContext.appInfoAreaContent === 'none') appContext.setAppInfoAreaContent('memo'); 
  }

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/airExport/mawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, '/airExport/mawb/add', NavigationType.newPage);
  }

  async function deleteMbl() {
    if (!selectedElement) {
      return;
    }

    if ((selectedElement.hblCount !== 'DBL' && selectedElement.hblCount !== '0')) {
      await showGlobalOkDialog('Need to delete HAWB first.',false,null,'warning');
      return;
    }

    // if (
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/edit/${selectedElement.id}`) || 
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/view/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close MAWB first', false, null, "warning");
    //   return;
    // }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/AEMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/AEMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/AEMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/AEMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/AEMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/AEMB/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.', false, null,'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.AEMbl, { id:selectedElement.id, pimsLinkId: selectedElement.pimsLinkId });
      if (apiResult && apiResult.success) {
        // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
        const editUrl = `/airExport/mawb/edit/${selectedElement.id}`;
        const viewUrl = `/airExport/mawb/view/${selectedElement.id}`;
        if (jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
          }

        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false, null,'warning');  
      }
    }
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 2;
    const baseUrl = '/airExport/mawb';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);

    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.AEMbl}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewProfit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 3;
    const baseUrl = '/airExport/mawb';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);
    
    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.AEMbl}TabIndexRequest${id}`] = tabIndex;
    }
    
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  async function moveToDeleteHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.AEDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.AEMbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToRecogHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.AERecogHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/recogHistory?jobname=${JobNames.AEMbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/airExport/mawb/edit/${id}`;
    const viewUrl = `/airExport/mawb/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/airExport/mawb/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/airExport/mawb/edit/${id}`;
    const viewUrl = `/airExport/mawb/view/${id}`;

    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEMbl, selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/airExport/mawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/airExport/mawb/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToHawb() {
    const selectedElement = jobListContext.selectedElement as AeMblListItem;
    if (selectedElement?.hblCount !== 'DBL') switchToHawbFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return { create, deleteMbl, edit, view, copy, switchToHawb, recognize, viewBillings, moveToDeleteHistoryReport, moveToRecogHistoryReport, viewProfit, openDocServer };
}

function useSelectedHawbOperation() {
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const selectedElement = jobListContext.selectedElement as AeHblListItem;
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const setSavedEntityAem = useSetEditedId([JobNames.AEMbl]);

  async function createHawb() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const newUrl = `/airExport/hawb/add?mawbRefId=${selectedElement.id}`;

    openNewPage(history, newUrl, NavigationType.newPage);
  }

  return { createHawb, setSavedEntityAem };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteMbl, edit, view, copy, switchToHawb, recognize, viewBillings, viewProfit } = useSelectedMawbOperation();
  const { createHawb } = useSelectedHawbOperation();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AeMblListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEMbl, selectedElement.branch);
  const hawbSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEHbl, selectedElement.branch, true);
  const fmsGlobal = getFmsGlobal();
  const setSavedEntityAfterClose = useSetEditedId([JobNames.AEHbl]);

  const userID = appContext.user ? appContext.user.id ?? '' : '';

  function openBLStatus() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.AEMbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult,false,null,'warning');
      return;
    }

      const hasOpened =
    jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/edit/${selectedElement.id}`) ||
    jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/view/${selectedElement.id}`)

    if (selectedElement.isClosed && hasOpened) {
      const editModelKey = `editAeMawb${selectedElement.id}-/airExport/mawb/edit`;
      const viewModelKey = `viewAeMawb${selectedElement.id}-/airExport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isFileClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;

        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AeHbl) => {
            hbl.fileClosed = 0;
          });
        }
      }

      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 0;
        fastStorage[viewKeyMatch].isFileClosed = false;
        fastStorage[viewKeyMatch].closedBy = '';
        fastStorage[viewKeyMatch].closeDate = null;

        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AeHbl) => {
            hbl.fileClosed = 0;
          });
        }
      }
    } else if (!selectedElement.isClosed && hasOpened) {
      const editModelKey = `editAeMawb${selectedElement.id}-/airExport/mawb/edit`;
      const viewModelKey = `viewAeMawb${selectedElement.id}-/airExport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      const closeDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_AOMMAIN',
        fieldName: 'F_CloseDate'
      });
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 1;
        fastStorage[keyMatch].isClosed = true;
        fastStorage[keyMatch].closedBy = userID;
        fastStorage[keyMatch].closeDate = closeDate;
        
        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AeHbl) => {
            hbl.fileClosed = 1;
          });
        }
      }

      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 1;
        fastStorage[viewKeyMatch].isClosed = true;
        fastStorage[viewKeyMatch].closedBy = userID;
        fastStorage[viewKeyMatch].closeDate = closeDate;
                
        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AeHbl) => {
            hbl.fileClosed = 1;
          });
        }
      }

    }

    setSavedEntityAfterClose('0', false, false, true);
    jobListContext.reloadData();
  }

  async function processAccountLock() {
    const accountLockResult = await appContext.api.accountClose(JobNames.AEMbl, selectedElement.id, !selectedElement.isAccountClosed);
    if (!!accountLockResult) {
      await showGlobalOkDialog(accountLockResult, false, null, 'warning');
      return;
    }

    const hasOpened =
      jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/view/${selectedElement.id}`)

    if (selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editAeMawb${selectedElement.id}-/airExport/mawb/edit`;
      const viewModelKey = `viewAeMawb${selectedElement.id}-/airExport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 0;
        fastStorage[keyMatch].isAccountClosed = false;
        fastStorage[keyMatch].accountClosedBy = '';
        fastStorage[keyMatch].accountCloseDate = null;

        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AeHbl) => {
            hbl.accountClosed = 0;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 0;
        fastStorage[viewKeyMatch].isAccountClosed = false;
        fastStorage[viewKeyMatch].accountClosedBy = '';
        fastStorage[viewKeyMatch].accountCloseDate = null;
        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AeHbl) => {
            hbl.accountClosed = 0;
          });
        }
      }
    } else if (!selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editAeMawb${selectedElement.id}-/airExport/mawb/edit`;
      const viewModelKey = `viewAeMawb${selectedElement.id}-/airExport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      const accountCloseDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_AOMMAIN',
        fieldName: 'F_AcctCloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 1;
        fastStorage[keyMatch].isAccountClosed = true;
        fastStorage[keyMatch].accountClosedBy = userID;
        fastStorage[keyMatch].accountCloseDate = accountCloseDate;
        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AeHbl) => {
            hbl.accountClosed = 1;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 1;
        fastStorage[viewKeyMatch].isAccountClosed = true;
        fastStorage[viewKeyMatch].accountClosedBy = userID;
        fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AeHbl) => {
            hbl.accountClosed = 1;
          });
        }
      }
    }

    setSavedEntityAfterClose('0', false, false, true);
    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock) && listSec?.grantEdit;
  let showAccountLock = (!selectedElement?.isAccountClosed ? getFmsGlobal().CanAccountLock : getFmsGlobal().CanAccountUnlock) && listSec?.grantEdit;
  // const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.confirmDate??'') < (getFmsGlobal().CloseDate??'');
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: false, hidden: !listSec?.grantDel },
    { label: 'New HAWB', shortcut: '', separator: true, disabled : selectedElement?.hblCount === 'DBL', hidden: !hawbSec?.grantAdd },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to HAWB List', shortcut: 'F6', separator: false, disabled : selectedElement?.hblCount === 'DBL', hidden: !hawbSec?.grantRead},
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: noBillingsShow&&noProfitShow, hidden: !listSec?.grantAdd },
    { label: 'Billings', shortcut: 'F7', separator: noProfitShow, hidden: noBillingsShow },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: noProfitShow},
    { label: 'Airline Status Update', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    { label: !selectedElement?.isAccountClosed ? 'Accounting Close' : 'Accounting Open', shortcut: '', separator: false, hidden: !showAccountLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize || !listSec?.grantEdit },
  ];

  const itemStatus = [
    { label: !selectedElement?.isClosed ? 'File Lock' : 'Unlock', shortcut: '', separator: false, hidden: !showFileLock },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem  name="aem-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteMbl();
        break;
      case 4:
        createHawb();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        switchToHawb();
        break;
      case 7:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 8:
        copy();
        break;
      case 9:
        viewBillings();
        break;
      case 10:
        viewProfit();
        break;
      case 11:
        openBLStatus();
        break;
      case 12:
        processFileLock();
        break;
      case 13:
        processAccountLock();
        break;
      case 14:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function MawbListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AeMblListItem;

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEMbl, selectedElement?.branch);

  const { copy, create, edit, view, switchToHawb, viewBillings, viewProfit } = useSelectedMawbOperation();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);
  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = !(fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = !(fmsGlobal.NoProfitShow ?? false);

  const hawbSec = findSecurityTask(appContext, FmsSecTask.AEHbl);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      if (hawbSec.grantRead)
        switchToHawb();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      if (noBillingsShow)
        viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      if (noProfitShow)
        viewProfit();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `MAWB #: ${(jobListContext.selectedElement as AeMblListItem|null)?.mawbNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.AEMbl}
      jobId={(jobListContext.selectedElement as AeMblListItem|null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function MawbListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function HawbRenderer({data, row, value}: any) {
  const {switchToHawbFor} = useMawbOperations();

  if (!value || value === 'DBL') {
    return <div className="ifms-table-default">{value}</div>;
  }

  if (value === '0') {
    return <div className="ifms-table-default">{value}</div>;
  }

  const isNumber = !isNaN(parseInt(value));

  if (!isNumber) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToHawbFor(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  return null;
}

function MawbListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  const selectedElement = jobListContext.selectedElement as AeMblListItem;

  const { deleteMbl, edit, view, copy, viewBillings, viewProfit, moveToDeleteHistoryReport, moveToRecogHistoryReport } = useSelectedMawbOperation();
  
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const setSavedEntityAfterRecog = useSetEditedId([JobNames.AEHbl, JobNames.SlipJournal]);
  const {switchJournal} = useJournal();
  // function hasOpenedViewOrEditFor(id:number) {
  //   return jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/view/${id}`);
  // }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/add`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAfterRecog('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.AEMbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }

  function hasOpenedViewOrEditFor(id:number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/view/${id}`);
  }

  const allowedStatuses = ['', 'E', 'D'];
  
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEMbl, selectedElement?.branch);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalOP, SecType.Read) && !userId.startsWith('@');

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  return (
    <div className="ifms-common-no-vertical-separator-gap-margin">
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='aem-list-add-button' display="primary" link="/airExport/mawb/add" disabled={!canBeAdd} label={<FontAwesomeIcon icon={faPlus} />} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='aem-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='aem-list-view-button' disabled={!hasSelectedRow} onClick={view} useText/>
        <DeleteIconButton2 name='aem-list-delete-button' disabled={!canBeDeleted} onClick={deleteMbl} useText/>
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <PrimaryButton name='aem-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
        {!noBillingsShow && <BillingsIconButton name='aem-list-billings-button' data-tooltip={constants.List_Billings} onClick={viewBillings} useText/>}
        {!noProfitShow && <PrimaryButton name='aem-list-profit-button' onClick={viewProfit} size="extrasmall" >Profit</PrimaryButton>}
        <DeleteHistoryIconButton onClick={moveToDeleteHistoryReport} useText/>
        <RecogHistoryIconButton onClick={moveToRecogHistoryReport} useText/>
        {!checkSecJournal && <JournalIconButton onClick={() =>  switchJournal(JobNames.AEMbl, selectedElement.id, "", null, selectedElement.refNo) } useText/>}
      </div>{
      !!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal noVerticalScroll isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.id} mTbName={"T_AOMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function formatData(data:Array<AeMblListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

function AfterMemoLogButtonCommands() {
  return null;
}

/**
 * Concrete implementation for AE MAWB List screen
 *
 * @class MawbListView
 * @extends {AbstractListView}
 */
 class MawbListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  airExportMawbList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const enableEawb = isEawbEnabled(suntekSettings);
    const cols = AeMblListItem.getExportCollection(useBranch, enableEawb);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }
  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }
  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'blType',
        renderer: BlTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }
   getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
      const useBranch = systemSettings?.enableBranch ?? false;
      const enableEawb = isEawbEnabled(suntekSettings);   // FWB/FHL/FRT Status 컬럼도 렌더러(중앙정렬 등)를 받도록 getTableSettings 와 동일하게 전달
     return AeMblListItem.getExportCollection(useBranch, enableEawb).map(x => {
       const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
       if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
       if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
       if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
       else if(x.dataIndex === 'memoCnt') { colRenderer.Cell = MemoDetailRenderer;}
       else if(x.dataIndex === 'refNo') {colRenderer.Cell = RefNoRenderer;}  
       else if (x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      //  else if (x.dataIndex === 'recognized') {
      //    colRenderer.Cell = RecognizedRenderer;
      //  }
       else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
       else if (x.dataIndex === 'hblCount') {
         colRenderer.Cell = HawbRenderer;
         colRenderer.Header = () => <span><u>HAWB</u>(s)</span>;
       }
       else if(x.dataIndex === 'agentName') colRenderer.Cell = AgentRenderer;
       else if (x.dataIndex === 'paidStatus') colRenderer.Cell = PaidRenderer;
       else if (x.dataIndex === "blType") colRenderer.Cell = BlTypeRenderer;
       else if (x.dataIndex === 'fwb' || x.dataIndex === 'fhl') colRenderer.Cell = EawbStatusRenderer;
       else if (x.dataIndex === 'fsu') colRenderer.Cell = FrtStatusRenderer;
       else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
       else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
       else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
       else if (x.type === XCol.XCellType.Double) {
         if (x.dataIndex === 'lChgWeight' || x.dataIndex === 'lGrossWeight' || x.dataIndex === 'pkgs')
           colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
         else if (x.dataIndex === 'chgWeight' || x.dataIndex === 'grossWeight')
           colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={1} />;
         else
           colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
       }
       return colRenderer;
     });
  }

   getExportRenderers(): ExportRowRenderer[] {
     const colRenderer = [];
     colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
     colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
     colRenderer.push({ accessor: 'lChgWeight', changedValue: (value: any) => { return value['lChgWeight'] } });
     colRenderer.push({ accessor: 'lGrossWeight', changedValue: (value: any) => { return value['lGrossWeight'] } });
     colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
     colRenderer.push({ accessor: 'chgWeight', changedValue: (value: any) => { return Decimalformat(value['chgWeight'], 1) } });
    colRenderer.push({ accessor: 'grossWeight', changedValue: (value: any) => { return Decimalformat(value['grossWeight'], 1) } });
     colRenderer.push({ accessor: 'blType', changedValue: (value: any) => { return formatAEBlType(value['blType']) } });
     return colRenderer;
   }

   async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number, opType: string): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.AEMbl,
      'AeMblListItem',
      AeMblListItem.calculateSearchParameters(search, AeMblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat', 'blType']),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

      if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
        return {data: [], totalCount: 0};
      }
  
      return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AEMbl, 'AeMblListItem',
      AeMblListItem.calculateSearchParameters(search, AeMblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat', 'blType']),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  formatData(apiResult.entities);
  }


  renderCommands(): React.ReactNode {
    return (
      <MawbListCommands />
    );
  }
  renderBeforeConfigureButton(): React.ReactNode {
    return (
      <MawbListToolbar />
    );
  }
  renderAfterConfigureButton(): React.ReactNode {
    return <></>
  }
  renderExtras(hideLogHistory: boolean): React.ReactNode {
    return <MawbListViewExtras hideLogHistory={hideLogHistory} />
  }
  getViewUrlFor(row: any): string {
    return row && row.id ? `/airExport/mawb/view/${row.id}` : '';
  }
  getListViewTitle(): string {
    return 'MAWB List';
  }
  
  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.AEMbl} keyProp='id' showAdjustBalance={false} />;
  }

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
    if (!rowId) {
      return null;
    }
    const storageKey = `ae-mbl-milestone-${rowId}`;
    const selectedElement = context.selectedElement as AeMblListItem;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEMbl, selectedElement?.branch);

    function onClose() {
      // fastStorage[storageKey] = null; // This is cleared in MilestonePopup
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="Airline Status Update" width="760px">
        <MawbMilestonePopup mawbId={rowId} storageKey={storageKey} onClose={onClose} isView={!listSec?.grantEdit} />
      </IfmsModal>
    );
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }
  
  useLogHistory(): boolean {
    return true;
  }
}

export default MawbListView;
